import { Role } from 'constants/roles';

export const EXPORT_FIELDS_REQUEST_BANK_OPS = [
  {
    index: '0',
    source: 'originId',
    label: 'ID',
  },
  {
    index: '1',
    source: 'dateOfOperation',
    label: 'Дата в ПС',
  },
  {
    index: '2',
    source: 'type',
    label: 'Тип операции',
  },
  {
    index: '3',
    source: 'direction',
    label: 'Направление',
  },
  {
    index: '4',
    source: 'amountPenny',
    label: 'Сумма',
  },
  {
    index: '5',
    source: 'currency',
    label: 'Валюта',
  },
  {
    index: '6',
    source: 'status',
    label: 'Статус',
  },
  {
    index: '7',
    source: 'referral',
    label: 'Реферал',
  },
  {
    index: '8',
    source: 'merchant',
    label: 'Мерчант',
  },
  {
    index: '9',
    source: 'provider',
    label: 'Провайдер',
  },
  {
    index: '10',
    source: 'merchantAccount',
    label: 'Счет мерчанта',
  },
  {
    index: '11',
    source: 'description',
    label: 'Комментарий',
  },
  {
    index: '12',
    source: 'user',
    label: 'Автор',
    excludeRoles: [Role.Finance],
  },
  {
    index: '13',
    source: 'createdAt',
    label: 'Дата создания',
  },
  {
    index: '14',
    source: 'updatedAt',
    label: 'Дата редактир.',
  },
];
